"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _getPrototypeOf = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FullJitterBackoff_1 = require("./FullJitterBackoff");

var FullJitterLimitedBackoff = /*#__PURE__*/function (_FullJitterBackoff_1$) {
  _inherits(FullJitterLimitedBackoff, _FullJitterBackoff_1$);

  var _super = _createSuper(FullJitterLimitedBackoff);

  function FullJitterLimitedBackoff(fixedWaitMs, shortBackoffMs, longBackoffMs, limit) {
    var _this;

    _classCallCheck(this, FullJitterLimitedBackoff);

    _this = _super.call(this, fixedWaitMs, shortBackoffMs, longBackoffMs);
    _this.limit = limit;
    _this.attempts = 0;
    return _this;
  }

  _createClass(FullJitterLimitedBackoff, [{
    key: "nextBackoffAmountMs",
    value: function nextBackoffAmountMs() {
      this.attempts++;

      if (this.attempts > this.limit) {
        throw new Error('retry limit exceeded');
      }

      return _get(_getPrototypeOf(FullJitterLimitedBackoff.prototype), "nextBackoffAmountMs", this).call(this);
    }
  }]);

  return FullJitterLimitedBackoff;
}(FullJitterBackoff_1.default);

exports.default = FullJitterLimitedBackoff;